import { useEffect } from 'react';
import { useFlag, useUnleashContext } from '@unleash/proxy-client-react';
import { useAppSelector } from '../redux/hooks';

export const useFeatureFlags = () => {
  const updateContext = useUnleashContext();
  const userInfo = useAppSelector((state) => state.userInfo.user);

  // Enable toggling of features by user name or ownerparty
  useEffect(() => {
    if (userInfo.name !== undefined) {
      void updateContext({
        properties: {
          userName: userInfo.name,
          ownerParty: userInfo.activeOwnerParty?.key ?? '',
        },
      });
    }
  }, [userInfo.name, userInfo.activeOwnerParty?.key]);

  const isDrpEnabled = useFlag('cargostream-drp-integration');

  return {
    isDrpEnabled,
  };
};
